import React from "react";
import {Link} from "react-router-dom";

const Footer = (props) => (
    <footer data-component="footer" className="padding-l-3-xs padding-r-3-xs padding-l-6-md padding-r-6-md">
        <div className="text-center bcs-footer">
          <ul>
              <li><Link to="/"><img src="https://s3.amazonaws.com/bcs-media-dev/ui/bcs-logo-solid.svg" alt="Bootcamp Spot home page" className="footer-logo"/></Link></li>
          </ul>
        </div>
    </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js